export default "__VITE_ASSET__CUMRR4Mv__"